import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div>Copyright © 2026 prodicus.in - All Rights Reserved.</div>
      {/* <div className="footer-links">
        <Link to="/admin-login">Admin Login</Link>
        <a href="#contact">Contact</a>
      </div> */}
    </footer>
  );
}
